import {
    FirestoreDataConverter,
    DocumentData,
    QueryDocumentSnapshot,
    SnapshotOptions,
} from 'firebase/firestore';
import { Shipment } from '../../Models';

const shipmentConverter: FirestoreDataConverter<Shipment> = {
    toFirestore(delivery: Shipment): DocumentData {
        return delivery;
    },
    fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): Shipment {
        const data = snapshot.data(options)!;
        return {
            id: snapshot.id,
            courier: 'cabify',
            creation_timestamp: data.creation_timestamp,
            estimate: data.estimate,
            parcels: data.parcels,
            round_trip: data.round_trip,
            trip_type: data.trip_type,
            update_timestamp: data.update_timestamp,
            order_id: data.order_id,
            pharmacy_id: data.pharmacy_id,
            state: data.state,
        };
    },
};

export default shipmentConverter;
